export default {
  "content": "<g clip-path=\"url(#icon_nav_transaction_selected_svg__a)\"><path d=\"M3.82 1.315L.53 4.695c-.35.36-.35.94 0 1.31.36.37.94.37 1.29 0l1.77-1.8v9.87c0 .5.39.93.91.93s.91-.43.91-.93v-9.89l1.77 1.81a.9.9 0 001.3 0c.35-.36.35-.94 0-1.3l-3.32-3.41a.885.885 0 00-1.33.04l-.01-.01zm8.36 13.36l3.29-3.38c.35-.36.35-.94 0-1.31a.888.888 0 00-1.29 0l-1.77 1.8v-9.86c0-.5-.39-.93-.91-.93s-.91.43-.91.93v9.88l-1.77-1.81a.888.888 0 00-1.29 0c-.35.36-.35.94 0 1.3l3.33 3.41a.885.885 0 001.33-.04l-.01.01z\"/></g><defs><clipPath id=\"icon_nav_transaction_selected_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};